(function () {
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  if (!window.MinimogTheme) {
    window.MinimogTheme = { config: {} };
  }

  window.MinimogTheme.config.mqlMobile = mobileQuery.matches;

  const emitBreakpointEvent = (matches) => {
    window.MinimogTheme.config.mqlMobile = matches;
    document.dispatchEvent(new Event(matches ? 'matchMobile' : 'unmatchMobile'));
  };

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', (event) => emitBreakpointEvent(event.matches));
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener((event) => emitBreakpointEvent(event.matches));
  }

  class FooterAccordion {
    constructor(container) {
      this.container = container;
      this.items = Array.from(container.querySelectorAll('.m-accordion--item'));
      this.handleClick = this.handleClick.bind(this);
      this.bind();
    }

    bind() {
      this.items.forEach((item) => {
        const button = item.querySelector('.m-accordion--item-button');
        if (!button) return;
        button.removeEventListener('click', this.handleClick);
        button.addEventListener('click', this.handleClick);
      });
      this.sync();
    }

    handleClick(event) {
      if (!window.MinimogTheme.config.mqlMobile) return;
      const item = event.currentTarget.closest('.m-accordion--item');
      if (!item) return;
      item.classList.toggle('open');
      this.sync();
    }

    sync() {
      this.items.forEach((item) => {
        const content = item.querySelector('.m-accordion--item-content');
        if (!content) return;

        if (!window.MinimogTheme.config.mqlMobile) {
          content.style.display = '';
          item.classList.add('open');
          return;
        }

        content.style.display = item.classList.contains('open') ? '' : 'none';
      });
    }
  }

  if (!window.MinimogLibs) {
    window.MinimogLibs = {};
  }

  window.MinimogLibs.Accordion = FooterAccordion;
})();
